import { resolveAssetUrl } from './resolveAssetUrl';

/** Delivery variant names from the image pipeline. */
export const STORY_COVER_VARIANTS = {
  THUMB: 'thumb',
  CARD: 'card',
  READER: 'reader',
  PDF: 'pdf',
};

export function getStoryCoverUrl(story, backendBaseUrl, variant = STORY_COVER_VARIANTS.CARD) {
  const urls = story?.cover_image_urls;
  if (urls?.[variant]) {
    return resolveAssetUrl(backendBaseUrl, urls[variant]);
  }
  if (variant !== STORY_COVER_VARIANTS.CARD && urls?.card) {
    return resolveAssetUrl(backendBaseUrl, urls.card);
  }
  if (story?.cover_image_url) {
    return resolveAssetUrl(backendBaseUrl, story.cover_image_url);
  }
  return null;
}

export function getStoryPrimaryTitle(story) {
  const custom = (story?.display_title || '').trim();
  if (custom) return custom;
  const prompt = (story?.question_text || '').trim();
  if (prompt) return prompt;
  return 'Untitled memory';
}

export function getStoryPromptLine(story) {
  const custom = (story?.display_title || '').trim();
  const prompt = (story?.question_text || '').trim();
  if (custom && prompt) return prompt;
  return null;
}

export function getStoryExcerpt(story, maxLen = 120) {
  const text = (story?.polished_transcript || story?.raw_transcript || '').trim();
  if (!text) return '';
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trim()}…`;
}

export function storyHasVoice(story) {
  if (!story) return false;
  if (story.audio_file_url) return true;
  if (Array.isArray(story.audio_segments) && story.audio_segments.length > 0) return true;
  return Boolean(story.duration_seconds);
}

export function getStoryDurationSeconds(story) {
  if (story?.duration_seconds != null && story.duration_seconds > 0) {
    return story.duration_seconds;
  }
  const segments = story?.audio_segments;
  if (Array.isArray(segments) && segments.length > 0) {
    return segments.reduce((sum, seg) => sum + (seg.duration_seconds || 0), 0) || null;
  }
  return null;
}

export function formatStoryDuration(seconds) {
  if (seconds == null || seconds <= 0) return null;
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function getFirstStoryAudioUrl(story, backendBaseUrl) {
  if (Array.isArray(story?.audio_segments) && story.audio_segments.length > 0) {
    const url = story.audio_segments[0]?.audio_file_url;
    if (url) return resolveAssetUrl(backendBaseUrl, url);
  }
  if (story?.audio_file_url) {
    return resolveAssetUrl(backendBaseUrl, story.audio_file_url);
  }
  return null;
}

export function storyCoverOriginalDownloadUrl(storyId, apiBase) {
  if (!storyId || !storyId.length) return null;
  return `${apiBase}/stories/${storyId}/cover-image/original`;
}
